import { z } from 'zod';
import { transformAndFilterValidEdges } from '../../../common/tools/transformEdgesUtils';
import { BaseResourceLibraryItemSchema } from './resourceLibraryBaseZodSchemas';
import { ImageSchema } from '../../../common/schemas/imageZodSchemas';

export const ResourceLibraryNewProductIntroductionBaseItemSchema =
    BaseResourceLibraryItemSchema.extend({
        coverImage: ImageSchema, // required
    }).describe('ResourceLibraryNewProductIntroductionBaseItemSchema');

export const ResourceLibraryNewProductIntroductionItemSchema =
    ResourceLibraryNewProductIntroductionBaseItemSchema.extend({
        headline: z.string(),
        body: z.string(),
        quickFacts: z.string(),
        features: z.string(),
        customerValues: z.string(),
        targetApplications: z.string(),
        closingSummary: z.string(),
        marketAdvantages: z.string(),
        productBrief: z.object({
            id: z.string(),
            __typename: z.enum(['object_ResourceLibraryItem', 'object_ResourceLibraryArticleItem']),
        }),
        similarProductsRoute: z.string(),
    }).describe('ResourceLibraryNewProductIntroductionItemSchema');

// Listing query returns base new product introduction items (without additional detail fields)
export const GetResourceLibraryNewProductIntroductionItemListingSchema = z
    .object({
        getResourceLibraryNewProductIntroductionItemListing: z.object({
            edges: z
                .array(
                    z.object({
                        node: z.unknown(),
                    })
                )
                .transform((edges) =>
                    transformAndFilterValidEdges(
                        ResourceLibraryNewProductIntroductionBaseItemSchema,
                        edges
                    )
                ),
        }),
    })
    .describe('GetResourceLibraryNewProductIntroductionItemListingSchema');

// Single item query returns full NPI items
export const GetResourceLibraryNewProductIntroductionItemSchema = z
    .object({
        getResourceLibraryNewProductIntroductionItem:
            ResourceLibraryNewProductIntroductionItemSchema,
    })
    .describe('GetResourceLibraryNewProductIntroductionItemSchema');
